var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "manageAutomationsModal",
    attrs: {
      id: "manage-automations-modal",
      "modal-dialog-size": "lg",
      "loaders-disabled": "",
      "modal-dialog-scrollable": false,
    },
    on: { show: _vm.handleShow },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("div", [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$tc("application.applicationHeader.muteAutomation", 2)
                  ) +
                  "\n      "
              ),
              _c("div", [
                _c("h6", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t(
                          "application.applicationHeader.useSelectorToMuteAutomation"
                        )
                      ) +
                      "\n        "
                  ),
                ]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.loading
              ? _c("manage-automations-loader")
              : [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        _vm._l(_vm.automationTypes, function (automationType) {
                          return _c(
                            "b-row",
                            { key: automationType.key, staticClass: "mb-2" },
                            [
                              _c("b-col", { attrs: { cols: "12" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card card-separator mb-2",
                                    style: _vm.getHeaderStyle(
                                      automationType.style
                                    ),
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "card-header px-3 py-2 bb-0",
                                      },
                                      [
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "d-flex flex-row justify-content-between align-items-center",
                                                attrs: { cols: "12" },
                                              },
                                              [
                                                _c("div", [
                                                  _c(
                                                    "h2",
                                                    {
                                                      staticClass:
                                                        "section-separator-title automation-separator-title-big",
                                                      style: _vm.getTitleColor(
                                                        automationType.style
                                                      ),
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(
                                                            automationType.label
                                                          ) +
                                                          "\n                        "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "h3",
                                                    {
                                                      staticClass:
                                                        "section-separator-title separator-subtitle text-uppercase",
                                                      style:
                                                        _vm.getDescriptionColor(
                                                          automationType.style
                                                        ),
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          " +
                                                          _vm._s(
                                                            automationType.description
                                                          ) +
                                                          "\n                        "
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-tooltip",
                                                        rawName:
                                                          "v-b-tooltip.left",
                                                        value: {
                                                          title:
                                                            "" +
                                                            (automationType.muted
                                                              ? _vm.$t(
                                                                  "application.applicationHeader.unMuteAutomation"
                                                                )
                                                              : _vm.$tc(
                                                                  "application.applicationHeader.muteAutomation",
                                                                  1
                                                                )),
                                                        },
                                                        expression:
                                                          "{\n                          title: `${\n                            automationType.muted\n                              ? $t(\n                                  'application.applicationHeader.unMuteAutomation'\n                                )\n                              : $tc(\n                                  'application.applicationHeader.muteAutomation',\n                                  1\n                                )\n                          }`\n                        }",
                                                        modifiers: {
                                                          left: true,
                                                        },
                                                      },
                                                    ],
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.toggleAutomationMute(
                                                          automationType.key,
                                                          automationType.muted
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    automationType.muted
                                                      ? _c("icon", {
                                                          staticClass:
                                                            "clickable fa-lg",
                                                          attrs: {
                                                            name: "ban",
                                                            "icon-class":
                                                              "text-danger",
                                                            stack: "",
                                                            "stack-icon-name":
                                                              "volume-off",
                                                            "stack-icon-class":
                                                              "text-gray",
                                                          },
                                                        })
                                                      : _c("icon", {
                                                          staticClass:
                                                            "text-gray clickable fa-lg mr-2",
                                                          attrs: {
                                                            name: "volume-off",
                                                          },
                                                        }),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { cols: "12" } }, [
                        _c(
                          "p",
                          {
                            staticClass: "mb-0 text-justify",
                            staticStyle: { "white-space": "normal" },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t(
                                    "application.applicationHeader.whenToggleIsOffForAutomation"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }